import { Typography } from 'antd'
import { ParagraphProps as ParagraphAntdProps } from 'antd/es/typography/Paragraph'
import { ReactNode } from 'react'

import s from '../Text.module.scss'

const { Paragraph: ParagraphAntd } = Typography

interface ParagraphProps extends ParagraphAntdProps {
  children: ReactNode
}

export const Paragraph = ({ children, ...props }: ParagraphProps) => {
  return (
    <ParagraphAntd {...props} className={s.text}>
      {children}
    </ParagraphAntd>
  )
}
